"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = HelpOutline;
var _HelpOutline = require("@adobe/react-spectrum-workflow/dist/HelpOutline.js");
var _icon = require("@react-spectrum/icon");
var _react = _interopRequireDefault(require("react"));
function HelpOutline(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_HelpOutline.A4uHelpOutline, null));
}